import { formatDateDistance } from '@magalu/stereo-ui-utils';
export const validateShortDescription = (description, charLimit) => {
  return (description == null ? void 0 : description.length) <= charLimit;
};
export const reduceDescription = (description, charLimit) => {
  return description == null ? void 0 : description.substring(0, charLimit).concat('...');
};
export const verifyTimestamp = date => {
  return /^\d+$/.test(date);
};
export const generateDateDistance = date => {
  return date && !verifyTimestamp(date) && formatDateDistance(new Date(date), new Date());
};
export const formatSubtitle = productAttributes => {
  return (productAttributes == null ? void 0 : productAttributes.map((el, index) => index === 0 ? `${el.label}: ${el.value}` : ` | ${el.label}: ${el.value}`)) || [];
};